import React from 'react';
import './ContactUs.css';
import Footer from '../UserPages/Footer';

function ContactUS() {
    return (
        <>
        <div className='info-contact'>
            <div className='contactus'>
                <div className='text'>
                    <h1>ติดต่อเรา</h1>
                    <div className='line2'></div>
                    <h1 className='h'>Contact Us</h1>
                </div>
            <div className='line1'></div>
            </div>

            <div className='content-contact'>
                <div className='icon'>
                <i class="fi fi-ss-map-marker"><p>ที่อยู่ : 100 หมู่16 ตำบลลานสะแก อำเภอพยัคฆภูมิพิสัย จังหวัดมหาสารคาม 44110</p></i>
                <i class="fi fi-sr-envelope"><p>อีเมล์ : Ppp123456@gmail.com</p></i>
                <i class="fi fi-sr-phone-call"><p>เบอร์ติดต่อ : 043 791 746</p></i>
                <i class="fi fi-sr-clock-three"><p>เวลาทำการ : วันจันทร์ - วันศุกร์ เวลา 8:30 น. - 15:30 น.</p></i>
                <a href='https://www.facebook.com/profile.php?id=100057449049222'><i class="fi fi-brands-facebook"><p>เพจเฟซบุ๊ก : โรงเรียนเทศบาลตำบลพยัคฆภูมิพิสัย</p></i></a>
                </div>

                <div className='googlemap'>
                    <p>แผนที่ :</p>
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3844.146480557285!2d103.19183047431693!3d15.530276253642256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311837c99f7f7885%3A0x4291ad1b9059cb74!2z4LmC4Lij4LiH4LmA4Lij4Li14Lii4LiZ4LmA4LiX4Lio4Lia4Liy4Lil4LiV4Liz4Lia4Lil4Lie4Lii4Lix4LiE4LiG4Lig4Li54Lih4Li04Lie4Li04Liq4Lix4Lii!5e0!3m2!1sth!2sth!4v1714108464230!5m2!1sth!2sth" 
                    width="100%" 
                    height="auto" 
                    style={{ border: '0' }} // Converted style to object style
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                </div>
            </div>
            <Footer/>
        </div>
        </>
    )
}

export default ContactUS